import React from 'react';

const BookingPage: React.FC = () => {
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-secondary-900 mb-6">
          Booking Plugin
        </h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-secondary-600">
            Booking plugin content will be displayed here.
            <br />
            <br />
            TODO: Implement booking plugin functionality.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookingPage;
